
export const fieldsConfig = [
  {
    name: "country_name",
    label: "Country Name",
    type: "text",
    required: true,
  },
  {
    name: "country_code",
    label: "Country Code",
    type: "text",
    required: true,
  },
];
